import React from 'react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { useSamouczek } from '../../context/SamouczekContext'
import OknoPowitania from './OknoPowitania'
import PanelSamouczka from './PanelSamouczka'
import Podswietlenie from './Podswietlenie'

/**
 * Samouczek „Pierwsze kroki” na każdej stronie (montowany w `App.js` obok porównywarki): okno powitania,
 * panel z krokami, podświetlenie miejsca i krótki komunikat po pominięciu całości. Stan: `SamouczekContext`.
 */
const Samouczek = () => {
  const s = useSamouczek()
  if (!s.dostepny) return null
  return (
    <>
      <OknoPowitania />
      <PanelSamouczka />
      {s.podswietlenie && (
        <Podswietlenie key={`${s.podswietlenie.klucz}:${s.podswietlenie.cel}`} cel={s.podswietlenie.cel}
                       dymek={s.podswietlenie.dymek} onZamknij={s.zamknijPodswietlenie} />
      )}
      {s.komunikat && (
        <div role="status" className="fixed bottom-4 right-4 z-40 flex max-w-sm items-start gap-3 rounded-2xl border border-gray-200 bg-white p-4 text-sm text-gray-700 shadow-lg print:hidden">
          <span className="flex-1">{s.komunikat}</span>
          <button type="button" onClick={s.zamknijKomunikat} aria-label="Zamknij"
                  className="-m-1 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-700">
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      )}
    </>
  )
}

export default Samouczek
